import { NavLink } from 'react-router-dom'
import NavItem from './NavItem'
import { navItems } from './nav_items'

const NavItems = () => {
  return (
    <div className="nav_items">
      {navItems.map(({ url, Icon, title }) => (
        <NavLink key={url} to={url} className="nav_item">
          <NavItem Icon={Icon} title={title} />
        </NavLink>
      ))}
    </div>
  )
}

export default NavItems
